module.exports = __webpack_public_path__ + "static/img/price.5628f33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/price.svg
// module id = Y87O
// module chunks = 1